import * as React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { styled } from '../theme';
import { PropsWithChildren } from 'react';

export interface LoaderWidgetProps {
  className?: any;
  fontSize?: string;
}

export const DEFAULT_LOADER_FONT_SIZE = '48px';

export const LoaderBackdrop: React.FC<PropsWithChildren<LoaderWidgetProps>> = (props) => {
  return <S.Container className={props.className}>{props.children}</S.Container>;
};

export const LoaderSpinner: React.FC<LoaderWidgetProps> = (props) => {
  return <S.Spinner icon="spinner" spin={true} fontSize={props.fontSize} className={props.className} />;
};

export const LoaderWidget: React.FC<LoaderWidgetProps> = (props) => {
  return (
    <LoaderBackdrop {...props}>
      <LoaderSpinner />
    </LoaderBackdrop>
  );
};

const BASE_LABEL = 'loader-widget';
namespace S {
  export const Container = styled.div`
    label: ${BASE_LABEL};
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.3);
    pointer-events: all;
  `;

  export const Spinner = styled(FontAwesomeIcon)<{ fontSize?: string }>`
    label: ${BASE_LABEL}__spinner;
    color: ${(p) => p.theme.text.secondary};
    font-size: ${(p) => p.fontSize ?? DEFAULT_LOADER_FONT_SIZE};
  `;
}
